import { CheckCircle2, Award, Users, BookOpen } from "lucide-react";
import { Button } from "@/components/ui/button";

const AboutSection = () => {
  const highlights = [
    "15,000+ successful consultations",
    "Expert in Numerology,Vedic Astrology, BNN & KP Astrology Vastu and Lal Kitab",
    "Trusted by families across Noida and Delhi NCR",
    "Personalized remedies and spiritual guidance",
  ];

  const features = [
    {
      icon: Award,
      title: "15+ Years",
      description: "Experience in Vedic Sciences",
    },
    {
      icon: Users,
      title: "15,000+",
      description: "Happy Clients Served",
    },
    {
      icon: BookOpen,
      title: "Expert",
      description: "Multiple Disciplines",
    },
  ];

  return (
    <section id="about" className="py-20 lg:py-32 bg-background relative">
      {/* Decorative Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground mb-4">
            About <span className="text-gradient-gold">Tapask Astrologer</span>
          </h2>
          <div className="section-divider mx-auto" />
        </div>

        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative">
              {/* Main Image */}
              <div className="relative rounded-2xl overflow-hidden border border-border/50">
                <img
                  src="/images/about_astrologer.png"
                  alt="About Tapask Astrologer - Cosmic Connection"
                  className="w-full h-[400px] lg:h-[500px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-background/20 to-transparent" />
              </div>

              {/* Stats Cards */}
              <div className="absolute -bottom-6 left-4 right-4 grid grid-cols-3 gap-3">
                {features.map((feature, index) => (
                  <div
                    key={index}
                    className="bg-card/95 backdrop-blur-sm border border-border rounded-xl p-4 text-center shadow-lg"
                  >
                    <feature.icon className="w-6 h-6 text-primary mx-auto mb-2" />
                    <p className="font-display text-lg font-semibold text-foreground">
                      {feature.title}
                    </p>
                    <p className="text-xs text-muted-foreground">
                      {feature.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <p className="text-lg text-muted-foreground leading-relaxed mb-6">
              Welcome to <span className="text-primary font-medium">Tapask Astrologer</span>, 
              where Pandit Tapas Dutta brings the ancient wisdom of  Astrology & Numerology to modern life. 
              With over <span className="text-foreground font-medium">15 years</span> of dedicated 
              practice, Pandit ji has been guiding thousands towards spiritual enlightenment and 
              divine solutions.
            </p>

            <p className="text-muted-foreground leading-relaxed mb-8">
              He believes that only those guided by divine grace come to him. His deep spiritual 
              connection allows him to understand his clients&apos; issues even before they share them. 
              This unique ability enables him to provide accurate predictions and effective remedies including Lal kitab and Other remedies,
              even when detailed information is unavailable.
            </p>

            {/* Highlights */}
            <div className="space-y-4 mb-8">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-primary mt-0.5 flex-shrink-0" />
                  <span className="text-foreground">{item}</span>
                </div>
              ))}
            </div>

            <a href="#services">
              <Button
                size="lg"
                className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-full px-8"
              >
                Explore Services
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
